import React, { useMemo } from "react";
import Loader from "../../../components/Loader";
import {
  convertStringToArray,
  extractDateFromStr,
  getLatestUpdatedObject,
  sanitizeString,
} from "../../../Utils/utils";
import { useNavigate } from "react-router-dom";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import usePagination from "../../../hooks/usePagination";
import Pagination from "../../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { imageUrl } from "../../../constants/constants";
import EventsDetail from "./EventsDetail";

const EventsDetailPage = () => {
  const { getText } = useLanguageTranslation();

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Events", "गतिविधियाँ")}
        titleLink="/events-detail"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Events", "गतिविधियाँ")}
      />

      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <EventsDetail />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default EventsDetailPage;
